var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPeru && _vm.isCreditCard)?_c('div',{staticClass:"section-visa"},[_c('img',{class:[
				'icon-visanet',
				{ 'loading': _vm.indeterminate } ],attrs:{"src":_vm.indeterminate ? null : _vm.iconVisa,"alt":"logo_visa"}}),_vm._v(" "),_c('p',{class:[
				'description-section-visa',
				{ 'loading': _vm.indeterminate } ]},[_vm._v(_vm._s(_vm.description))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7edd7078","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/section-visa.vue
// module id = 1082
// module chunks = 30